/*
 * @Description: 聚合推广门店列表
 * @Author: maowy
 * @Date: 2020-7-16 18:28:16
 * @LastEditTime: 2020-7-16 18:28:16
 * @LastEditors: maowy
 */
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import {
    getNearbySstores
} from '@/models/storeList'
import infiniteLoadData from '@/components/infiniteLoadData/infiniteLoadData.vue'
import mergeSpreadSearch from './mergeSpreadSearch/mergeSpreadSearch'
export default {
    name: viewName.mergeSpreadStoreList,
    components: {
        infiniteLoadData,
        mergeSpreadSearch
    },
    data () {
        return {
            clientHeight: 0,
            currentSelected: '',
            count: 0,
            nearbySstoresList: [],
            isload: true,
            param: { // type 0-代表查询活动数据 1-不需要查询秒杀活动
                sstore_name: '',
                goods_id: '',
                latitude: '',
                longitude: '',
                page: 0,
                pagesize: 20,
                type: 1,
                spec_id: ''
            }
        }
    },
    computed: {
        ...mapState({

        }),
    },
    created () {

    },
    activated () {

    },
    mounted () {
        const { goods_id, topic_id, latitude, longitude, spec_id } = this.$route.query
        this.$emit('setHeader', {
            title: '选择门店',
            showHeader: true,
            showLeft: true,
            hasSearch: false
        })
        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
        Object.assign(this.param, {
            goods_id,
            topic_id,
            latitude,
            longitude,
            spec_id
        })
    },
    methods: {
        ...mapActions([
            'getNearbySstores',
            'setAppClass'
        ]),
        initParams () {
            Object.assign(this.param, {
                sstore_name: '',
                page: 0,
                pagesize: 20,
            })
            this.nearbySstoresList = []
        },
        onSearch (name) {
            this.initParams()
            Object.assign(this.param, {
                sstore_name: name
            })
            this.getPageList()
        },
        // 获取门店-分页
        getPageList () {
            if (this.nearbySstoresList.length <= this.count) {
                this.param.page++
                this.isload = true
                this.getData(this.param)
            } else {
                //  到底部了。
                // this.getData(param)
                this.isload = false
            }
        },
        getData () {
            getNearbySstores(this.param).then(res => {
                const { list, total_count } = res
                this.count = total_count
                this.nearbySstoresList = this.nearbySstoresList.concat(list)
                this.$nextTick(() => {
                    this.clientHeight = Number(document.querySelector('.searchBox').clientHeight) + Number(document.querySelector('.store-list-count').clientHeight)
                })
                // 返回数据 < 最大条目数
                if (list.length < this.param.pagesize) {
                    this.isload = false
                } else {
                    this.isload = true
                }
            }).catch(_ => {
                this.isload = false
            })
        },
        changeSelected (id) {
            if (id === this.currentSelected) {
                this.currentSelected = ''
            } else {
                this.currentSelected = id
            }
        },
        /**
         * 上拉加载数据，在这里进行操作
         */
        scrollToEnd (scroll) {
            this.isload && this.getPageList()
        },
        /**
         * 监听是否初始化成功
         */
        init (scroll) {
            this.scroll = scroll
            this.getPageList()
        },
        selectedStore (item) {
            let { goods_id, spu_id, goods_type, spec_id, topic_id } = this.$route.query
            if (item) {
                let jumpParam = {
                    goods_id,
                    spu_id,
                    sstore_id: item.id,
                    goods_type,
                    spec_id,
                    topic_id,
                }
                this.$router.push({
                    name: 'goodsDetail',
                    query: jumpParam
                })
            }
        }
    },
}
